import { LogEntry } from 'lib-shared-legacy-types';

import { LogEntry as LogEntryComponent } from './logEntry';

type ConversationTranscriptionStartedProps = {
  entry: LogEntry;
};

export const ConversationTranscriptionStarted = ({
  entry,
}: ConversationTranscriptionStartedProps): JSX.Element => {
  const text = <>Conversation transcription started</>;
  return <LogEntryComponent entry={entry} text={text} />;
};
